import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  role: "table",
  class: "flex flex-col justify-start items-start gap-4"
}
const _hoisted_2 = {
  role: "rowheader",
  class: "grow shrink self-stretch px-4 md:px-5 py-3 bg-racq-anti-flash-white rounded-tl rounded-tr border-l border-r border-t border-racq-blue-background flex-col justify-start items-start gap-2.5 flex"
}
const _hoisted_3 = { class: "self-stretch text-racq-dark-grey text-base-bold" }
const _hoisted_4 = {
  key: 0,
  class: "self-stretch px-4 md:px-5 py-4 bg-white rounded-bl rounded-br border border-racq-blue-background flex-col justify-start items-start flex"
}
const _hoisted_5 = {
  key: 1,
  class: "self-stretch justify-start items-center flex"
}
const _hoisted_6 = { class: "self-stretch text-racq-med-grey text-m richtext" }

import { Text, RichText, Field } from '@sitecore-jss/sitecore-jss-vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'TableSet',
  props: {
    tableSet: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableSet?.rows, (row, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        role: "row",
        class: "self-stretch flex-col justify-start items-start flex"
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(Text), {
              field: row.title
            }, null, 8, ["field"])
          ])
        ]),
        (row.cols.length === 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.cols, (col, colIndex) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: colIndex,
                  role: "cell",
                  class: "self-stretch text-racq-med-grey text-m richtext"
                }, [
                  _createVNode(_unref(RichText), {
                    field: col.text
                  }, null, 8, ["field"])
                ]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.cols, (col, colIndex) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: colIndex,
                  role: "cell",
                  class: "w-6/12 self-stretch px-4 md:px-5 py-4 bg-white rounded-bl border-l border-t border-b last-of-type:border-r last-of-type:rounded-bl-none last-of-type:rounded-br border-racq-blue-background flex-col justify-start items-start flex"
                }, [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_unref(RichText), {
                      field: col.text
                    }, null, 8, ["field"])
                  ])
                ]))
              }), 128))
            ]))
      ]))
    }), 128))
  ]))
}
}

})